/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const BattleCalc = require('../../BattleCalc');
const { logError } = require('../../logger');

const Q_buff_ally = function (buffHandle, actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.buffAbility = BattleCalc.getEquippedAbility(actor, buffHandle);

  switch (buffHandle) {
    case 'bless':
      node.buffCondition = 'blessed';
      break;
    case 'summon_option':
      node.buffCondition = 'has_option';
      break;
    case 'poison_weapon':
      node.buffCondition = 'poisoner';
      break;
    default:
      logError('invalid buffHandle', {
        module: 'Q_buff_ally',
        func: 'constructor',
        buffHandle,
        actor,
        battleState,
      });
      break;
  }

  if (!node.buffAbility) {
    node.branches[node.YES] = node.branches[node.NO];
  }

  node.getUnitWithoutBuff = function () {
    const candidates = [];

    for (const unit of Object.values(battleState.allUnits)) {
      if (unit.team === actor.team && !BattleCalc.getCondition(unit, node.buffCondition)) {
        candidates.push(unit);
      }
    }

    if (candidates.length > 0) {
      let closest_dist = Infinity;
      let closest_candidate;
      for (const candidate of candidates) {
        const dist = BattleCalc.boardDistance(actor, candidate);
        if (dist < closest_dist) {
          closest_dist = dist;
          closest_candidate = candidate;
        }
      }
      return closest_candidate;
    }

    return null;
  };

  node.query = function () {
    if (!this.buffAbility) {
      return this.branches[this.NO].query();
    }

    var unitWithoutBuff = this.getUnitWithoutBuff();

    if (unitWithoutBuff) {
      return this.branches[this.YES].query(unitWithoutBuff);
    } else {
      return this.branches[this.NO].query();
    }
  };

  return node;
};
module.exports = Q_buff_ally;
